/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-globals */
import {
  List, Box, Divider, Input, Button, Snackbar, Alert,
} from '@mui/material';
import { Product } from 'components/Product/Product';
import { BASEURL } from 'context/context';
import React, { useEffect, useState } from 'react';
import { IProduct } from 'types/productType';

export type ICartProductListProps = {

}

const CartProductList: React.FC<ICartProductListProps> = ({ }) => {
  const [cartProducts, setCartProducts] = useState<IProduct[]>([]);
  const [cartItems, setCartItems] = useState<number[]>([]);
  const [discount, setDiscount] = useState<boolean>(false);
  let discountCode = '';

  /// alert snackbar
  const [open, setOpen] = React.useState('');

  const handleClick = (data: string) => {
    setOpen(data);
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen('');
  };

  const updateDiscount = () => {
    let discountPrice = 0;
    if (!discount) {
      return 0;
    }

    try {
      cartProducts.forEach((product) => {
        const count = cartItems.filter((item) => item === parseInt(product.uid, 10)).length;
        discountPrice += parseInt(product.sellingPrice.substring(1), 10) * count * 0.1;
      });
    } catch (e) {
      return 0;
    }
    return Math.floor(discountPrice);
  };

  const verifyDiscount = async () => {
    const userId = localStorage.getItem('userId');

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      userId,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const result = await fetch(`${BASEURL}/getUserDiscount`, requestOptions as any);
    const userCode = await result.text();

    if (userCode === discountCode) {
      setDiscount(true);
    } else {
      setDiscount(false);
    }

    return userCode;
  };

  const getTotalPrice = () => {
    let totalPrice = 0;

    try {
      cartProducts.forEach((product) => {
        const count = cartItems.filter((item) => item === parseInt(product.uid, 10)).length;
        totalPrice += parseInt(product.sellingPrice.substring(1), 10) * count;
      });
    } catch (e) {
      return 0;
    }
    return totalPrice;
  };

  const fetchProducts = async (productIds: number[]) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const cartProductList = [];

    for (let i = 0; i < productIds.length; i++) {
      const startIndex = productIds[i];

      const raw = JSON.stringify({
        startIndex,
        limit: 1,
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      try {
        const fetchProductResults = await fetch(`${BASEURL}/allProducts`, requestOptions as any);
        const productResults = await fetchProductResults.json();

        cartProductList.push(...productResults);
      } catch (e) {
        console.log(e);
      }
    }
    setCartProducts(cartProductList);
  };

  const getCartItems = () => {
    const cart = localStorage.getItem('cart');
    if (cart == null) {
      return;
    }
    const cartItemsList = cart.split(';');
    const parseCartItemsList: number[] = [];

    for (let i = 0; i < cartItemsList.length; i++) {
      const item = parseInt(cartItemsList[i], 10);
      if (!isNaN(item)) {
        parseCartItemsList.push(item);
      }
    }

    setCartItems(parseCartItemsList);
    fetchProducts(Array.from(new Set(parseCartItemsList)));
  };

  const purchaseCartItems = async () => {
    const userId = localStorage.getItem('userId');
    let code = '';

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    if (discount) {
      code = await verifyDiscount();
    }

    const raw = JSON.stringify({
      userId,
      discountCode: code,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    try {
      const result = await fetch(`${BASEURL}/purchaseCartItems`, requestOptions as any);
      const response = await result.text();

      console.log(response);
      handleClick('success');

      setTimeout(() => {
        localStorage.removeItem('cart');
        location.href = '/';
      }, 3000);
    } catch (e) {
      handleClick('failure');
      console.log(e);
    }
  };

  useEffect(() => {
    getCartItems();
  }, []);

  if (cartProducts.length === 0) {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
        <h2>No products in cart</h2>
      </Box>
    );
  }

  return (
    <>
      <List sx={{
        height: 'calc(100% - 220px)',
        overflowY: 'scroll',
      }}
      >
        {
          cartProducts.map((product: IProduct) => (
            <Product
              key={product.uid}
              product={product}
              callback={getCartItems}
            />
          ))
            }
      </List>
      <Box>
        <Divider />
        <Box sx={{
          padding: '8px',
        }}
        >
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
          }}
          >
            <Input
              placeholder="Enter Discount Code"
              inputProps={{ 'aria-label': 'description' }}
              onChange={(e) => { discountCode = e.target.value; }}
              sx={{
                flexGrow: 1,
                width: '100%',
              }}
            />
            <Button onClick={verifyDiscount}>Apply</Button>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            mt: '5px',
            mr: '20px',
            ml: '20px',
          }}
          >
            <Box>Total Price</Box>
            <Box>{`$${getTotalPrice()}`}</Box>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            mt: '5px',
            mr: '20px',
            ml: '20px',
          }}
          >
            <Box>Discount Price</Box>
            <Box>{`$${updateDiscount()}`}</Box>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            mt: '5px',
            mr: '20px',
            ml: '20px',
          }}
          >
            <Box>
              Amount to be Paid:
              {' '}
              {`$${getTotalPrice() - updateDiscount()}`}
            </Box>
            <Button onClick={purchaseCartItems}>Purchase</Button>
          </Box>
        </Box>
      </Box>
      <Snackbar open={open === 'success'} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Product purchased successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={open === 'failure'} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Product purchased successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

export { CartProductList };
